import 'react-app-polyfill/ie9'
import 'react-app-polyfill/ie11'
import 'babel-polyfill'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import i18n, { prepareLanguage } from './i18n'
import * as serviceWorker from './serviceWorker'
import * as Sentry from '@sentry/react'
import { BrowserRouter } from 'react-router-dom'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'
import smoothscroll from 'smoothscroll-polyfill'
import Analytics from 'react-router-ga'
import { GetExternalUrlsFromDomain } from 'polaris-adventures-js'

smoothscroll.polyfill()

const { BackendApi } = GetExternalUrlsFromDomain(
  'WaiverWeb',
  window.location.origin,
  process.env.REACT_APP_LOCAL_DEV_BACKEND
)

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  release: process.env.PA_APP_VERSION,
  environment: process.env.REACT_APP_ENV,
  autoSessionTracking: true,
  tracePropagationTargets: [BackendApi],
  tracesSampleRate: 0.1,
  profilesSampleRate: 0.1,
  errorSampleRate: 1.0,
  integrations: [Sentry.browserTracingIntegration(), Sentry.browserProfilingIntegration()],
  beforeSend(event, hint) {
    // don't send errors from local dev
    if (process.env.REACT_APP_ENV === 'local') return null

    event.extra = event.extra || {}
    if (hint.originalException != null) {
      // Assign enumerable error properties to extras
      try {
        const keys = Object.keys(hint.originalException)
        if (keys.length) {
          event.extra.errorProperties = {}
          keys.forEach((key) => {
            event.extra.errorProperties[key] = hint.originalException[key]
          })
        }
      } catch (error) {
        console.warn('[sentry] Failed to assign enumerable error properties to extras', error)
      }
    }
    return event
  },
  beforeBreadcrumb(breadcrumb, hint) {
    if (breadcrumb.category === 'ui.click') {
      const { target } = hint.event
      if (target.ariaLabel) {
        breadcrumb.message = target.ariaLabel
      }
      if (target.id) {
        breadcrumb.message = target.id
      }
    }
    return breadcrumb
  }
})

const theme = createMuiTheme({
  palette: {
    primary: { main: '#0D287F' },
    secondary: { main: '#ffffff' }
  },
  status: {
    danger: 'orange'
  },
  typography: {
    useNextVariants: true
  }
})

i18n.init().then(() => {
  prepareLanguage()
  const root = createRoot(document.getElementById('root'))
  root.render(
    <BrowserRouter>
      <Analytics id={process.env.REACT_APP_GA_ID} debug={process.env.REACT_APP_GA_DEBUG}>
        <MuiThemeProvider theme={theme}>
          <App />
        </MuiThemeProvider>
      </Analytics>
    </BrowserRouter>
  )
})

serviceWorker.unregister()
